<template>
  <FormattedMessage
    v-if="stepId === 'main' || stepId === 'product_comment'"
    class="caption"
    :definition="translations.legalText"
    tag="p"
  >
    <template #privacy>
      <RevLink target="_blank" :to="privacyLink">
        {{ i18n(translations.privacyLink) }}
      </RevLink>
    </template>

    <template #otherTerms>
      <RevLink target="_blank" :to="otherTermsLink">
        {{ i18n(translations.otherTermsLink) }}
      </RevLink>
    </template>
  </FormattedMessage>
</template>

<script lang="ts" setup>
import FormattedMessage from '@backmarket/nuxt-module-i18n/FormattedMessage.vue'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevLink } from '@ds/components/Link'
import type { Location } from '@ds/types/Location'

import type { StepId } from '~/api/reviews/types/GetReviewCollectionResponse'
import { useRouteLocationWithLocale } from '~/composables/useRouteLocationWithLocale'
import { CMS } from '~/scopes/cms/routes-names'
import { LEGAL_PAGE_NAME } from '~/scopes/legal/constants'

import translations from './LegalText.translations'

const resolveLocalizedRoute = useRouteLocationWithLocale()
const privacyLink: Location = resolveLocalizedRoute({
  name: CMS.LEGAL_PAGE,
  params: {
    pageName: LEGAL_PAGE_NAME.DATA_PROTECTION,
  },
})

const otherTermsLink: Location = resolveLocalizedRoute({
  name: CMS.LEGAL_PAGE,
  params: {
    pageName: LEGAL_PAGE_NAME.OTHER,
  },
})

defineProps<{ stepId: StepId | null }>()

const i18n = useI18n()
</script>
